export default __webpack_public_path__ + "static/media/monthly-tournament-thumb.a2640ed5.png";